import {
  Survey,
  SurveyMetadataFormState,
  SurveyQualificationsFormState,
  SurveyQuotasFormState,
  surveyToMetadataForm,
} from '@ps/survey-utils';

import { SuppliersMetaData } from '../survey-creation-suppliers-meta-data-state.model';

export function buildMetadataFormStateFromSurvey(
  survey: Survey,
): SurveyMetadataFormState {
  return {
    value: surveyToMetadataForm(survey),
    valid: true,
    errors: [],
    isDirty: false,
  };
}

export function buildQualificationsFormStateFromSurvey(
  survey: Survey,
): SurveyQualificationsFormState {
  return {
    value: survey.qualifications ?? [],
    valid: true,
    errors: [],
    isDirty: false,
  };
}

export function buildQuotasFormStateFromSurvey(
  survey: Survey,
): SurveyQuotasFormState {
  return {
    value: survey.quotas ?? [],
    valid: true,
    errors: [],
    isDirty: false,
  };
}

export function buildSuppliersMetaDataFromSurvey(
  survey: Survey,
): SuppliersMetaData {
  return { blendId: survey.blendId };
}
